exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.col-xs[data-v-0cb740da] {\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\ninput[data-v-0cb740da] {\n  width: 30px;\n}\n.image[data-v-0cb740da]{\n  -ms-flex: 0 0 121px;\n      flex: 0 0 121px;\n}\n.price-original[data-v-0cb740da] {\n  text-decoration: line-through;\n  color: #828282;\n  font-size: .95rem;\n}\n", ""]);

// exports
